import * as React from 'react';

import classNames from 'classnames';

import GenericIconProps from './icon.type';

export default function ExpandLessIcon({ className = '', viewBox = '0 0 24 24', size }: GenericIconProps) {
  return (
    <svg className={classNames(className, size)} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.875 14.5C6.725 14.3667 6.65 14.1957 6.65 13.987C6.65 13.779 6.725 13.6 6.875 13.45L11.375 8.97501C11.4583 8.87501 11.5543 8.80401 11.663 8.76201C11.771 8.72068 11.8833 8.70001 12 8.70001C12.1167 8.70001 12.2293 8.72068 12.338 8.76201C12.446 8.80401 12.5417 8.87501 12.625 8.97501L17.15 13.475C17.2833 13.625 17.35 13.7957 17.35 13.987C17.35 14.179 17.275 14.35 17.125 14.5C16.975 14.65 16.8 14.725 16.6 14.725C16.4 14.725 16.225 14.65 16.075 14.5L12 10.45L7.9 14.525C7.76667 14.675 7.6 14.75 7.4 14.75C7.2 14.75 7.025 14.6667 6.875 14.5Z" />
    </svg>
  );
}
